export default {
    name: "MyOpenConversationsWidget",
    type: "DataWidget",
    description: "Shows a list of open conversations assigned to the current user.",
    roles: ["user"],
    widget: {
        title: "My Open Conversations",
        dataProvider: {
            main: {
                rpc: "UserDashboardRpc.getMyOpenConversations",
                transform: (response) => response?.data || []
            }
        },
        async enrichData(data, appClient) {
            if (data.main && data.main.length > 0) {
                const enrichmentPromises = data.main.map(async (convo) => {
                    if (convo.contactId) {
                        const contact = await appClient.rds.get('projectContacts', convo.contactId);
                        convo.contactName = contact ? contact.displayName || `${contact.firstName} ${contact.lastName}` : 'Unknown Contact';
                    } else {
                        convo.contactName = 'Unknown Contact';
                    }
                    return convo;
                });
                data.main = await Promise.all(enrichmentPromises);
            }
            return data;
        },
        itemAction: {
            type: 'navigate',
            route: '/user/inbox?conversationId={{_id}}'
        },
        itemTemplate: (item) => {
            const channelIcons = {
                "voice": "bi-telephone-fill", "sms": "bi-chat-text-fill", "whatsapp": "bi-whatsapp",
                "email": "bi-envelope-fill", "web_chat": "bi-chat-dots-fill", "facebook_messenger": "bi-messenger",
                "instagram": "bi-instagram", "telegram": "bi-telegram"
            };
            const icon = channelIcons[item.channelType] || 'bi-question-circle-fill';
            const snippet = item.lastInteractionSnippet ? item.lastInteractionSnippet.substring(0, 60) + (item.lastInteractionSnippet.length > 60 ? '...' : '') : 'No recent message';
            const statusColor = item.status === 'pending' ? 'warning' : 'info';

            return `
                <style>
                    .my-convo-card { padding: 0.75rem; border-left: 4px solid var(--bs-${statusColor}); background-color: var(--bs-tertiary-bg); border-radius: var(--bs-border-radius); margin-bottom: 0.5rem; }
                </style>
                <div class="my-convo-card">
                    <div class="d-flex align-items-center">
                        <div class="fs-4 me-3 text-muted"><i class="bi ${icon}"></i></div>
                        <div class="flex-grow-1">
                            <div class="fw-bold">${item.contactName}</div>
                            <div class="text-muted fst-italic small">${snippet}</div>
                        </div>
                    </div>
                </div>
            `;
        },
        noDataMessage: "You have no open conversations."
    }
};
